import { SourcesProvider } from '@api/types.gen';

import { FormControl } from '@@/form-components/FormControl';
import { PortainerSelect, Options } from '@@/form-components/PortainerSelect';
import { CustomComponents } from '@@/form-components/PortainerSelectCustomRenderers';
import { Icon } from '@@/Icon';

import { providerConfigs } from './providerConfig';

type Props = {
  value: SourcesProvider;
  onChange: (provider: SourcesProvider) => void;
};

const providerOptions: Options<SourcesProvider> = (
  Object.keys(providerConfigs) as SourcesProvider[]
).map((value) => ({
  label: providerConfigs[value].title,
  value,
}));

export function GitProviderSelect({ value, onChange }: Props) {
  return (
    <FormControl label="Git Provider" inputId="git-provider">
      <PortainerSelect
        inputId="git-provider"
        value={value}
        options={providerOptions}
        onChange={onChange}
        data-cy="git-provider-select"
        components={CustomComponents<SourcesProvider>((v) => (
          <div className="flex items-center gap-1">
            <Icon icon={providerConfigs[v.value].icon} size="md" />
            {v.label}
          </div>
        ))}
      />
    </FormControl>
  );
}
